<div class="planned-ride-warning-message-container">
  <svg-icon src="/assets/icons/warning.svg" svgAriaLabel="limit reached" i18n-svgAriaLabel />
  @if (hasUnroutableError) {
    <span i18n>Maximum ride length reached.</span>
  } @else {
    <span i18n>Point limit reached</span>
    <a
      id="openWarningMessage"
      href="javascript:void(0);"
      rdcAnalytics="Open Planned Ride Max Point Warning Message"
      (click)="openPlannedRideMaxPointMessage()"
    >
      <svg-icon class="info-icon" src="/assets/icons/info.svg" svgAriaLabel="information" i18n-svgAriaLabel />
    </a>
  }
</div>
